import {ValveType, valveTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<ValveType>;

export const ValveTypeSelect = (props: Props) => {
    const {options = valveTypes, ...rest} = props;
    return <BaseDbCodeSelect options={options} {...rest} />;
};
